import {
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Text,
} from '@chakra-ui/react';
import { useField } from 'formik';

export const SliderField = ({ item, field }) => {
  if (!item) return null;
  const { name, isEditable = true, disabled } = item;
  const [_field, meta, helpers] = useField(name); // eslint-disable-line
  const { setValue } = helpers;

  return (
    <Slider
      {...field}
      id={name}
      disabled={!isEditable || disabled}
      defaultValue="20"
      onChange={(val) => {
        setValue(val);
      }}
      min={item?.min || 0}
      max={item?.max}
      step={item?.step}
    >
      <SliderTrack bg="#E3E3ED" h="6px">
        <SliderFilledTrack bg="ats-primary" />
      </SliderTrack>
      <SliderThumb
        width="32px"
        height="24px"
        borderRadius="sm"
        boxShadow="none"
        bg="ats-primary"
        _focus={{}}
      >
        <Text color="#fff" size="sm-medium">
          {meta?.value}
        </Text>
      </SliderThumb>
    </Slider>
  );
};
